import { translate } from '../i18n/index';

export const AUTH_EXCEPTIONS = {
    AUTH_FAILED: 'AUTH_FAILED',
    MISSING_EMAIL_AND_CELLPHONE: 'MISSING_EMAIL_AND_CELLPHONE',
    MISSING_EMAIL: 'MISSING_EMAIL',
    MISSING_CELLPHONE: 'MISSING_CELLPHONE',
    USER_NOT_CONFIRMED: 'User is not confirmed.',
    USER_ALREADY_CONFIRMED: 'User cannot be confirmed. Current status is CONFIRMED',
};

export const verifyIntegrationError = (message) => {
    const splittedDescription = message.split(';');
    console.log(splittedDescription);
    if (message.includes('email: This value is already used')) {
        return 'Email já cadastrado!';
    }

    if (splittedDescription.length > 1) {
        return splittedDescription[1];
    }

    if (message.includes('ERROR:')) {
        const formattedMessage = message.replace(/ERROR:/i, '').replace(/- tag:.*/i, '');
        return formattedMessage;
    }

    return 'Ocorreu um erro ao cadastrar o usuário!';
};

export const verifyError = (code, message, store = null) => {
    switch (code) {
        case 'CodeMismatchException':
            return translate('codeMismatchExceptionInvalidVerificationCode');
        case 'NotAuthorizedException':
            return translate('notAuthorizedExceptionIncorrect');
        case 'UsernameExistsException':
            return translate('usernameExistsExceptionEmailAlreadyExists');
        case 'UserNotConfirmedException':
            return translate('userNotConfirmedExceptionUserIsNotConfirmed');
        case 'UserNotFoundException':
            if (message.includes(AUTH_EXCEPTIONS.MISSING_EMAIL_AND_CELLPHONE)) {
                return translate('userNotFoundExceptionEmailAndPhoneNotFound');
            }

            if (!store) {
                return translate('userNotFoundExceptionNotFoundCustomOnFarm');
            }
            return translate('userNotFoundExceptionNotFoundCustomOnFarmStore');
        case 'PhoneNumberNotFound':
            return translate('userNotFoundExceptionPhoneNotFound');
        case 'EmailNotFound':
            return translate('userNotFoundExceptionEmailNotFound');
        default:
            return message;
    }
};

export const passwordValidation = (value, setPasswordValidate) => {
    let obj = {};

    if (value.length >= 6) {
        obj = Object.assign(obj, { min: true });
    } else {
        obj = Object.assign(obj, { min: false });
    }

    if (/[0-9]/gm.test(value)) {
        obj = Object.assign(obj, { number: true });
    } else {
        obj = Object.assign(obj, { number: false });
    }

    setPasswordValidate(obj);
};

export const confirmPasswordValidation = (value, passwordEntered, setConfirmPasswordValidate) => {

    let obj = {};
    console.log('teste obj: ', obj);

    if (value.length >= 6) {
        obj = Object.assign(obj, { min: true });
    } else {
        obj = Object.assign(obj, { min: false });
    }
    setConfirmPasswordValidate(obj);
};
